import {
  Button,
  usePagination,
} from "@mui/material"
import { useEffect } from "react"
import { makeStyles } from "@mui/styles"
import { styled } from "@mui/material/styles"
import cssVariables from "../theme/cssVariables"
import { useTranslation } from "react-i18next"

const CustomPagination = (props) => {
  const { t } = useTranslation();
  const useStyles = makeStyles({
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
  })
  const classes = useStyles();
  const List = styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex"
  });
  const { items } = usePagination({
    count: props.count,
    showFirstButton: true,
    showLastButton: true,
  })
  useEffect(() => {
    props.setCurrentPage(items)
  }, [items])
  return (
    <nav>
      <List>
        {items.length > 0 ? (
          items.map(({ page, type, selected, ...item }, index) => {
            let children = null;
            selected =
              type === "page" && page === props.selected
                ? props.selected
                : selected;
            if (type === "start-ellipsis" || type === "end-ellipsis") {
              children = "…";
            } else if (type === "page") {
              children = (
                <Button
                  {...item}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {page}
                </Button>
              );
            } else if (type === "first" || type === "last") {
              children = (
                <Button
                  {...item}
                  disabled={
                    type === "first"
                      ? props.selected === 1
                        ? true
                        : false
                      : props.selected === props.count
                        ? true
                        : false
                  }
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                </Button>
              );
            } else {
              children = (
                <Button
                  {...item}
                  disabled={
                    type === "previous"
                      ? props.selected === 1
                        ? true
                        : false
                      : props.selected === props.count
                        ? true
                        : false
                  }
                  size="small"
                  type="button"
                  variant="outlined"
                  classes={{
                    root: classes.paginationRoot,
                  }}
                >
                  {type === "previous"
                    ? t("label.previous")
                    : type === "next"
                      ? t("label.next")
                      : ""}
                </Button>
              );
            }
            return <li key={index}>{children}</li>;
          })
        ) : (
          <></>
        )}
      </List>
    </nav>
  )
}
export default CustomPagination;
